/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import _ from 'underscore';
import StringResources from 'nls/StringResources';
import { sortCards } from './actionHelper';

/**
 * Models the duplicate card action
 */
class DuplicateAction {
	constructor(options) {
		this.exploreVM = options.exploreVM;
		this.layoutModel = options.layoutModel;
	}

	getAttributes() {
		return {
			id: 'duplicate',
			//no icon yet - need to add one if this action is to appear in the toolbar
			label: StringResources.get('card_sidebar_duplicate'),
			className: null
		};
	}

	isEnabled(cards) {
		return !!cards.length;
	}

	action(cards) {
		//Duplicate cards in order they appear in the exploration
		cards = sortCards(cards, this.layoutModel);

		// pass payload with transaction id. Duplicating multiple cards is grouped into one action
		const payload = {
			undoRedoTransactionId: _.uniqueId('duplicateCards')
		};

		const duplicatedIds = this.layoutModel.duplicateCards(cards, undefined, payload);

		this.exploreVM.setBestDisplayedToCard(duplicatedIds);
	}
}

export { DuplicateAction };



// WEBPACK FOOTER //
// ./src/js/components/cards/actions/DuplicateAction.js